(() => {
  const mount = (root) => {
    if (!root || root.dataset.mcReady) return;
    root.dataset.mcReady = 'true';
    const toolbar = root.querySelector('[data-mc-toolbar]');
    const openButton = root.querySelector('[data-mc-open]');
    const dialog = root.querySelector('[data-mc-dialog]');
    const map = root.querySelector('[data-mc-map]');
    const template = root.querySelector('[data-mc-map-template]');
    let pendingFrame = false;
    const updateOffset = () => {
      pendingFrame = false;
      root.style.setProperty('--mc-toolbar-height', `${toolbar.offsetHeight}px`);
    };
    const scheduleOffset = () => {
      if (!pendingFrame) {
        pendingFrame = true;
        requestAnimationFrame(updateOffset);
      }
    };
    updateOffset();
    window.addEventListener('scroll', scheduleOffset, { passive: true });
    window.addEventListener('resize', scheduleOffset, { passive: true });
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(scheduleOffset);
      resizeObserver.observe(toolbar);
    }
    if (openButton && dialog && template) {
      openButton.hidden = false;
      openButton.addEventListener('click', () => {
        if (!map.children.length) map.append(template.content.cloneNode(true));
        dialog.showModal();
      });
      root.querySelector('[data-mc-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
        const jump = event.target.closest('[data-mc-jump]');
        if (!jump) return;
        event.preventDefault();
        const target = root.querySelector(jump.getAttribute('href'));
        dialog.close();
        if (target) {
          root.querySelector('.mc-card-selected')?.classList.remove('mc-card-selected');
          target.classList.add('mc-card-selected');
          history.replaceState(null, '', jump.getAttribute('href'));
          requestAnimationFrame(() => {
            target.scrollIntoView({ behavior: 'instant', block: 'start' });
            target.querySelector('a').focus({ preventScroll: true });
          });
        }
      });
    }
    const links = [...root.querySelectorAll('[data-mc-family]')];
    const groups = [...root.querySelectorAll('[data-mc-group]')];
    const selectFamily = (family) => {
      links.forEach(link => {
        if (link.dataset.mcFamily === family) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };
    links.forEach(link => link.addEventListener('click', () => selectFamily(link.dataset.mcFamily)));
    if (groups.length) selectFamily(groups[0].dataset.mcGroup);
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) selectFamily(entry.target.dataset.mcGroup); });
      }, { rootMargin: '-20% 0px -65% 0px', threshold: 0 });
      groups.forEach(group => observer.observe(group));
    }
  };
  document.querySelectorAll('[data-mc-root]').forEach(mount);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-mc-root]').forEach(mount);
  });
})();
